// Local imports
import { main } from '../sgproduct/lib.js';
import { noheader_main } from './lib.js';

main();
noheader_main();
